import React from 'react';
import { Paper, Box, Typography, Divider, IconButton } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import { fontSize } from '../../../../node_modules/@mui/system/index';
const DetailTemplate = ({ children, title, isLocked, handleLockClick, hideLock, prjTyp}) => {
  return (
    <>
      <Paper
      variant="outlined"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          my:1
        }}
      >
        <Box
          sx={{
            px: 2,
            py: 0.3,
            backgroundColor:'#424242',
            color:'#fff'
          }}
        >
          <Typography variant="subtitle1" component="div" 
            sx={{ 
              display: 'flex', 
              alignItems: 'center', // 수직 중앙 정렬
              gap: 0.5 // 텍스트와 아이콘 사이의 간격 (mr 대신 권장)
            }}
          >
            {title} 
            {((title === '기본사항' || (title === '매출 계산서 발행 예정 내역' && prjTyp === 'M')) && hideLock) && (
              <>
                <IconButton onClick={handleLockClick} size="small" sx={{ p: 0 }}>
                  {isLocked ? (
                    <LockIcon sx={{ fontSize: '1.4rem', color: 'common.white' }} />
                  ) : (
                    <LockOpenIcon sx={{ fontSize: '1.4rem', color: 'primary.light' }} />
                  )}
                </IconButton>
                <Typography
                  variant="subtitle1"
                  component="div"
                  sx={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: 0.5, 
                    fontSize: '13px', // 문구가 길어질 수 있어 소폭 축소
                    color: 'common.white' 
                  }}
                > 
                  {/* title에 따른 문구 분기 */}
                  {title === '기본사항' 
                    ? '(기본 사항 수정이 필요시 자물쇠를 클릭하여 풀어주세요.)' 
                    : '(기본 사항의 계약 기간 변경 필요시 자물쇠를 클릭하여 풀어주세요 내용은 변경된 계약 기간에 맞추어 초기화 됩니다.)'}
                </Typography>
              </>
            )}
          </Typography>
        </Box>
        <Divider />
        <Box
          sx={{
            mt: 1,
            px: 2,
            pb:2,
          }}
        >
          {children}
        </Box>
      </Paper>
    </>
  );
};

export default DetailTemplate;
